import EXIF from './exif';
import(/* webpackPrefetch: true */ './exif');

function fileImage2DataURL(file: Blob) {
  return new Promise<string>((resolve, reject) => {
    if (!file) {
      reject('');
    }

    const fileReader = new FileReader();
    fileReader.onload = function(this: FileReader) {
      const imgDataURL = this.result;
      if (typeof imgDataURL !== 'string') {
        reject('');
      } else {
        resolve(imgDataURL);
      }
    };
    fileReader.onerror = function() {
      reject('');
    };

    fileReader.readAsDataURL(file);
  });
}

const testAutoOrientationImageURL =
  'data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAA' +
  'AAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBA' +
  'QEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQE' +
  'BAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAEAAgMBEQACEQEDEQH/x' +
  'ABKAAEAAAAAAAAAAAAAAAAAAAALEAEAAAAAAAAAAAAAAAAAAAAAAQEAAAAAAAAAAAAAAAA' +
  'AAAAAEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8H//2Q==';

function supportsAutomaticRotation(): Promise<boolean> {
  return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
          // Check if browser supports automatic image orientation:
          const supported = img.width === 1 && img.height === 2;
          resolve(supported);
      };
      img.src = testAutoOrientationImageURL;
  });
}

const autoRotateSupported = supportsAutomaticRotation();

/**
 * 通过exif.js获得的图片方向
 */
function getImageOrientation(file: Blob) {
  return new Promise<number | undefined>((resolve, reject) => {
    try {
      autoRotateSupported.then((supported: boolean) => {
        if (supported) {
          resolve(undefined);
        } else {
          EXIF.getData(file, function() {
            EXIF.getAllTags(this);
            const orientation = EXIF.getTag(this, 'Orientation');
            resolve(orientation);
          });
        }
      })
    } catch (e) {
      console.error('error:', e);
      reject(undefined);
    }
  });
}

export {
  fileImage2DataURL,
  getImageOrientation
};
